import { defineComponent } from 'vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import ProfileHeader from '@/components/profile/ProfileHeader.vue';
import ProfileDetails from '@/components/profile/ProfileDetails.vue';
import router from '@/router';
export default defineComponent({
    name: 'ProfileView',
    components: {
        TransactHeader,
        ProfileHeader,
        ProfileDetails,
    },
    setup() {
        const goBack = () => {
            router.push('/');
        };
        return { goBack };
    },
});
